class RcModal extends HTMLElement {
  constructor() {
    super();
    this._overlay = null;
    this._closeBtn = null;
    this._onOpenEvent = this._onOpenEvent.bind(this);
    this._onOverlayClick = this._onOverlayClick.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._onCloseBtnClick = () => this.toggleVisibility(false);
    this._onModalCloseEvent = () => this.toggleVisibility(false);
  };

  connectedCallback() {
    if(this.getAttribute('aria-hidden') === null) this.setAttribute('aria-hidden', 'true');
    this._overlay = this.querySelector('.rc-modal-overlay');
    this._closeBtn = this.querySelector('.rc-modal-close');
    this._overlay.addEventListener('click', this._onOverlayClick);
    this._closeBtn.addEventListener('click', this._onCloseBtnClick);
    window.addEventListener('modal-open', this._onOpenEvent);
    window.addEventListener('modal-close', this._onModalCloseEvent);
    window.addEventListener('keydown', this._onKeydown);
  };

  disconnectedCallback() {
    if(this._overlay) this._overlay.removeEventListener('click', this._onOverlayClick);
    if(this._closeBtn) this._closeBtn.removeEventListener('click', this._onCloseBtnClick);
    window.removeEventListener('modal-open', this._onOpenEvent);
    window.removeEventListener('modal-close', this._onModalCloseEvent);
    window.removeEventListener('keydown', this._onKeydown);
  };

  _onOverlayClick(e) {
    // Ensure we only close when clicking the overlay itself
    if(e.target === this._overlay) this.toggleVisibility(false);
  }

  _onOpenEvent(e) {
    // Optional scoping: if event has detail.id, only open when matching
    const targetId = e?.detail?.id;
    if(targetId && this.id && targetId !== this.id) return;
    this.toggleVisibility(true);
  };

  toggleVisibility(isOpen) {
    this.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.setAttribute('data-overlay-active', isOpen ? 'true' : 'false');
  };

  _onKeydown(e) {
    if(e.key === 'Escape') this.toggleVisibility(false);
  };

};

if(!customElements.get('rc-modal')) customElements.define('rc-modal', RcModal);